module.exports = __webpack_public_path__ + "static/media/climatizacion-coche.07210037.png";